import http from 'src/infrastructure/http'
import { parseFailedResponse, parseGoodResponse } from 'src/infrastructure/parse-axios-response'
import { getFulfillmentCenterSelected } from 'src/services/fulfillmentCenter/fulfillmentCenterService'
import {
  GenericApiErrors,
  DivergenceFilters,
  DivergenceFilterOptionsResponse,
  ValidatedManagerBadge,
  StartDivergenceResolutionPayload,
  StartDivergenceResolutionResponse,
  ProductNotFoundResponse,
  StartItemResolutionResponse,
  ValidateProductResponse,
  ValidateProductApiPayload,
  ProductNotFoundApiPayload,
  StartItemResolutionApiPayload,
  ValidateManagerBadgeApiPayload,
  DivergenceApiResponse,
} from './DivergenceDemandsTypes'

const startDivergenceResolution = async (payload: StartDivergenceResolutionPayload) => {
  try {
    const params = {
      divergenceId: payload.divergenceId,
      prodBarcode: payload.prodBarcode,
    }

    const config = {
      params,
      headers: { 'user-barcode': payload.userBadge },
    }

    const result = await http.get('/v2/stock-divergence-demand/start-divergence-resolution', config)
    return parseGoodResponse<StartDivergenceResolutionResponse>(result.data.data)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

const validateProduct = async (payload: ValidateProductApiPayload) => {
  try {
    const params = {
      divergenceId: payload.divergenceId,
      prodBarcode: payload.prodBarcode,
    }

    const config = {
      params,
      headers: { 'user-barcode': payload.userBadge },
    }

    const result = await http.get('/v2/stock-divergence-demand/validate-product', config)
    return parseGoodResponse<ValidateProductResponse>(result.data.data)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

const productNotFound = async (payload: ProductNotFoundApiPayload) => {
  try {
    const { userBadge, ...restPayload } = payload

    const config = {
      headers: { 'user-barcode': userBadge },
    }

    const result = await http.post('/v2/stock-divergence-demand/product-not-found', restPayload, config)
    return parseGoodResponse<ProductNotFoundResponse>(result.data.data)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

const startItemResolution = async (payload: StartItemResolutionApiPayload) => {
  try {
    const { userBadge, ...restPayload } = payload

    const config = {
      headers: { 'user-barcode': userBadge },
    }

    const result = await http.post('/v2/stock-divergence-demand/start-item-resolution', restPayload, config)
    return parseGoodResponse<StartItemResolutionResponse>(result.data.data)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

const validateManagerBadge = async (payload: ValidateManagerBadgeApiPayload) => {
  try {
    const { badge, divergenceId, setUser } = payload
    const url = `/v2/stock-divergence-demand/validate-manager-badge/${divergenceId}${setUser ? '?setUser=true' : ''}`
    const resultSuccess = await http.post(url, null, {
      headers: { 'user-barcode': badge },
    })
    return parseGoodResponse<ValidatedManagerBadge>(resultSuccess.data.data)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

const getDivergence = async (filters?: DivergenceFilters) => {
  try {
    const fcSelected = getFulfillmentCenterSelected()
    const params = {
      ...(filters && Object.keys(filters).length > 0 ? filters : {}),
      ...(fcSelected?.id && { idFulfillmentCenter: fcSelected.id }),
    }

    const result = await http.get('/v2/stock-divergence-demand', { params })
    return parseGoodResponse<DivergenceApiResponse>(result.data)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

const getDivergenceFilterOptions = async () => {
  try {
    const result = await http.get('/v2/stock-divergence-demand/filter-options')
    return parseGoodResponse<DivergenceFilterOptionsResponse>(result.data)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

export default {
  validateManagerBadge,
  getDivergence,
  getDivergenceFilterOptions,
  startDivergenceResolution,
  validateProduct,
  productNotFound,
  startItemResolution,
}
